/**
 * Services/Index Controller
 *
 * Displays a list of orders of all services, or a specified service
 */

// the constructor for this object
function ServicesIndexController() { }

// the object
ServicesIndexController.prototype = {
    constructor: ServicesIndexController,
    
    // the product group to search for (if extended)
    productGroup: false,
    
    // the product code to search for (if extended)
    productCd: false,
    
    // this contains the pagination object
    pagination: false,
    
    // the number of order per page
    perPage: 20,
    
    // the last data submitted to the API, used to prevent multiple api requests
    lastSubmittedData: {},
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        // set up the pagination
        this._setupPagination();
        
        // build the accounts dropdown used in the invoice widget
        this._setupAccountsDropdown();
        
        PortalHelper.debugMessage('Services Index Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the pagination events
        this.pagination.init();
    
        // set headline
        this._setHeadline();
        
        // set breadcrumbs
        this._setBreadcrumbs();
        
        // get and populate the orders
        this._getOrders();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Services Index Controller Ran');
    },
    
    // create the pagination object
    _setupPagination: function()
    {
        var pagination = new PortalPagination;
        pagination.perPage = this.perPage;
        pagination.paginationSelector = '#orders-pagination';
        pagination.contentSelector = '#orders-table';
        pagination.searchSelector = '#portal-search';
        pagination.searchColumn = 'search_all';
        pagination.eventCallback = PortalMain.ServicesIndexController._getOrders;
        PortalMain.ServicesIndexController.pagination = pagination;
    },
    
    // build the accounts dropdown used in the invoice widget
    _setupAccountsDropdown: function()
    {
        // populate the accounts dropdown, and rerun the controller on change
        var servicesAccountSelector =  new PortalAccountSelector();
        servicesAccountSelector.setupAccountsDropdown(
            '#account-selection',
            function(currentAccountId) {
            
                PortalHelper.loadingOverlay('#orders-table', true);
                PortalHelper.loadingOverlay('#orders-pagination', true);
                
                PortalMain.ServicesIndexController.pagination.setPage(1);
                
                // get the orders using the new account id
                PortalMain.ServicesIndexController._getOrders();
            }
        );
        this.servicesAccountSelector = servicesAccountSelector;
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        // set the product group or code
        if (segments.length == 1) {
            // if the string is 2 characters long it is a product code, otherwise a group
            if (segments[0].length == 2) {
                this.productCd = segments[0];
            } else {
                this.productGroup = segments[0];
            }
        }
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        // download the csv file of the orders when clicked
        $('.download-orders').on('click', function(e) {
            e.preventDefault();
            
            PortalMain.ServicesIndexController._downloadOrders();
        });
    },
    
    // get the orders from the api
    _getOrders: function()
    {
        // get the submission data from the pagination object
        var submissionData = PortalMain.ServicesIndexController.pagination.getBaseSubmissionData();
        
        // include the account id with the data
        var currentAccountId = PortalMain.PortalAccounts.getCurrentAccountId();
        if (currentAccountId != 0) {
            submissionData.accountId = currentAccountId;
        }
        
        // set the product group if this controller was extended by a specific product
        if (PortalMain.ServicesIndexController.productGroup !== false) {
            var group = PortalMain.PortalProducts.getProductGroup(PortalMain.ServicesIndexController.productGroup);
            submissionData.search_product_group = group.label;
        }
        
        // set the product code if this controller was extended by a specific product
        if (PortalMain.ServicesIndexController.productCd !== false) {
            submissionData.search_product_cd = PortalMain.ServicesIndexController.productCd
        }
        
        // make sure the new request isn't the same as the previous one
        if (JSON.stringify(submissionData) == JSON.stringify(PortalMain.ServicesIndexController.lastSubmittedData)) {
            PortalMain.ServicesIndexController.pagination.showPagination();
            return;
        }
        PortalMain.ServicesIndexController.lastSubmittedData = submissionData;
        
        // make the request
        var ordersRequest = new PortalRequest;
        ordersRequest.pageNumber = submissionData.page;
        ordersRequest.makeRequest(
            '/orders/get-orders',
            submissionData,
            function(data) {
                
                //handle pagination 
                PortalMain.ServicesIndexController.pagination.updatePagination(data);
                PortalMain.ServicesIndexController.pagination.showPagination();
                
                // fill the invoice chart data
                PortalMain.ServicesIndexController._populateOrdersTable(data);
            }
        );
    },
    
    // download the orders csv from the api
    _downloadOrders: function()
    {
        PortalHelper.loadingOverlay('#orders-pagination', true);
        
        // get the submission data from the pagination object
        var submissionData = PortalMain.ServicesIndexController.pagination.getBaseSubmissionData();
        
        // set the product group if this controller was extended by a specific product
        if (PortalMain.ServicesIndexController.productGroup !== false) {
            var group = PortalMain.PortalProducts.getProductGroup(PortalMain.ServicesIndexController.productGroup);
            submissionData.search_product_group = group.label;
        }
        
        // set the product code if this controller was extended by a specific product
        if (PortalMain.ServicesIndexController.productCd !== false) {
            submissionData.search_product_cd = PortalMain.ServicesIndexController.productCd
        }
        
        // make the request
        var downloadOrdersRequest = new PortalRequest;
        downloadOrdersRequest.pageNumber = submissionData.page;
        downloadOrdersRequest.isBinary = true;
        downloadOrdersRequest.makeRequest(
            '/orders/download-orders',
            submissionData,
            function(data) {
                PortalHelper.loadingOverlay('#orders-pagination', false);
                
                // build the file name
                var fileName = $('#headline').html().replace(/ /g,'-');
                fileName += '.csv';
                
                // download the file
                PortalHelper.downloadFile(data, fileName);
            },
            function() {
                PortalHelper.loadingOverlay('#orders-pagination', false);
                PortalHelper.openErrorPopup(
                    'Download Error',
                    'There was an error downloading this file. This may be because there are no services to download. Change your search settings, and try again.'
                );
            }
        );
    },
    
    // set the headline according to the current product
    _setHeadline: function()
    {
        var headline = 'All Services';
        
        // add the product group
        if (this.productGroup !== false) {
            var group = PortalMain.PortalProducts.getProductGroup(this.productGroup);
            headline = group.label;
        }
        
        // add the product
        if (this.productCd !== false) {
            var product = PortalMain.PortalProducts.getProduct(this.productCd);
            headline = product.product;
        }
        
        // append service at the end if not there
        if (!headline.match("Service$") && !headline.match("Services$")) {
            headline += ' Services';
        }
        
        $('#headline').html(headline);
    },
    
    // set the headline according to the current product
    _setBreadcrumbs: function()
    {
        if (this.productGroup !== false) {
            var url = '/portal/services';
            $('.breadcrumbs a:last-of-type').after('<a href="' + url + '">Services</a>');
            
            var group = PortalMain.PortalProducts.getProductGroup(this.productGroup);
            $('.breadcrumbs span').html(group.label);
        }
        
        if (this.productCd !== false) {
            var url = '/portal/services';
            $('.breadcrumbs a:last-of-type').after('<a href="' + url + '">Services</a>');
            
            var group = PortalMain.PortalProducts.getProductGroupByProductCd(this.productCd);
            if (group) {
                var groupUrl = '/portal/services/' + group.path;
                $('.breadcrumbs a:last-of-type').after('<a href="' + groupUrl + '">' + group.label + '</a>');
            }
            
            var product = PortalMain.PortalProducts.getProduct(this.productCd);
            $('.breadcrumbs span').html(product.product);
        }
        
        $('.breadcrumbs').removeClass('hidden');
    },
    
    // populate the orders table
    _populateOrdersTable: function(ordersData)
    {    
        var orders = ordersData.data;
        
        // clear the old tickets
        $('#orders-table tbody tr:not(.clone-source)').remove();
        
        // add the new tickets to the DOM
        for (var i in orders) {
            var order = orders[i];
            var newEntry = $('#orders-table tbody .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // apply the view link
            var viewLink = PortalMain.PortalProducts.getProductLink(order.product_cd, order.base_order_id);
            $('.view-link', newEntry).attr('href', viewLink);
            
            // apply the product name
            $('.product', newEntry).html(order.product);    
            
            // apply the order number
            $('.order-number', newEntry).html(order.order_number);
            
            // apply the uss circuit id
            $('.uss-circuit-id', newEntry).html(order.uss_circuit_id);
            
            // apply the customer reference
            var reference = order.customer_ref == null ? '' : order.customer_ref;
            $('.customer-reference', newEntry).html(reference);
            
            // apply the alias
            var alias = order.alias == null ? '' : order.alias;
            $('.alias', newEntry).html(alias);
            
            // apply the mrc charges
            var dollars = PortalHelper.numberToDollars(order.mrc_charges);
            $('.mrc-charges', newEntry).html(dollars);
            
            // add to to the table
            $('#orders-table tbody').append(newEntry);
        }
        
    },
    
    
}